import { render, staticRenderFns } from "./doctorTeam.vue?vue&type=template&id=6fcf6758&scoped=true&"
import script from "./doctorTeam.vue?vue&type=script&lang=js&"
export * from "./doctorTeam.vue?vue&type=script&lang=js&"
import style0 from "./doctorTeam.vue?vue&type=style&index=0&id=6fcf6758&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcf6758",
  null
  
)

export default component.exports